module.exports = __webpack_public_path__ + "img/Airbnb-Work-From-Home-Seating.4a9083b4.jpg";